export default __webpack_public_path__ + "27354390ded1ee967e0d02a926382872.png";